const timeout = (period: number) =>
  new Promise<never>((resolve, reject): void => {
    setTimeout(() => reject(new Error("timeout")), period);
  });

export const withTimeout = <Type>(
  fn: () => Type,
  period = 30000,
): Promise<Type> => Promise.race<Type>([fn(), timeout(period)]);
